module.exports = __webpack_public_path__ + "img/tab-15.2da46a7e.png";